import React from "react";

const JQuery_Slide = () => {
  return (
    <div>
      <h1>JQuery_Slide</h1>
      <p>Placeholder component for: "JQuery_Slide"</p>
    </div>
  );
};

export default JQuery_Slide;
